import React from 'react';
import { Button, Col } from 'antd';

import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';

export const RequestReceivedPresentational = ({ onFinish }) => {
	return (
		<>
			<ImageComponent className="verify_back" src={images.fullscreen} />
			<Col className="center_area">
				<Col className="body">
					<ImageComponent className="logo" src={images.logo_sm} />
					<Col className="head">Request Received</Col>
					<Col className="content1" style={{ textAlign: 'center' }}>
						Your request has been submitted.
					</Col>
					<Col className="content"> Please monitor your email for the status of your request</Col>
					<Col className="btn_area">
						<Col className="wd-200">
							<Button className="k_btn" onClick={onFinish}>
								Close
							</Button>
						</Col>
					</Col>
				</Col>
			</Col>
		</>
	);
};
